//
//
//
//
//
//

import FootNav from './components/FootNav.vue'

export default {
    name: 'app',
    components: {FootNav}
}



// WEBPACK FOOTER //
// ./src/App.vue